module.exports = __webpack_public_path__ + "static/img/cstSer_bg_02.dff2ac3e.svg";